export default "__VITE_ASSET__BmCu8Bid__"